(function () {
  // Omniture variables
  var s_code;
    var $resultsContainer;

  var $conf = $('.js-conf');
  var filtersConf = {
    $modal: $('.js-filters-modal'),
    $bar: $('.js-filters-bar')
  };
  var currentMobile;
  var listCtrl;

  $resultsContainer = $('.js-results-container');


  currentMobile = eeGlobal.mqDetector.isMobile();

  listCtrl = new ListControllerCompanies({
    $conf: $conf,
    $paginationContainer: $('.js-pagination'),
    $resultsContainer: $resultsContainer,
    $breadCrumbContainer: $('.js-bread-crumb-wrapper'),
    filtersOptions: filtersConf
  });

  $(window).on('resize', function () {
    if (currentMobile != eeGlobal.mqDetector.isMobile()) {
      window.location = window.location;
    }
  });

  // Omniture Init Page
  s.channel = "elempleo: personas: busquedas empresas";
  s.pageName = "elempleo: personas: resultados empresas";
  
  s_code = s.t();

  // Omniture
  if (s_code) {
    document.write(s_code);
  }

  $resultsContainer.on('click', '.js-view-company', function(event) {
    var companyId = $(event.currentTarget).data('company-id');
    s.linkTrackVars = 'events,eVar50';
    s.linkTrackEvents = 'event101';
    s.events = 'event101';
    s.eVar50 = companyId;
    s.tl(true, 'o', 'Ver empresa');
  });

    function generateCompanyData(element) {
        var $this = $(element);

        var companyId = $this.data('company-id').toString();
        var companyName = $this.data('name');
        var position = $this.data('position');
        var sector = $this.closest('.result-item').find('.info-sector').text().trim();
        var imgTitle = $this.closest('.result-item').find('img.img-responsive').attr('title') || '';

        var companyData = {
            section: 'EMPRESAS REGISTRADAS',
            elementId: companyId,
            elementName: companyName,
            elementlistName: 'Sitios Y Bases Empresariales',
            elementlistId: 'sitios_y_bases_empresariales',
            elementPosition: position,
            elementBrand: imgTitle.trim(),
            elementCategory: 'Empresa',
            elementCity: 'Bogota',
            elementQuantity: '1',
            elementSector: sector,
            elementSubsector: '',
            elementNumberEmployees: ''
        };

        return companyData;
    }

    function handleCompanyClick(event) {
        var element = event.currentTarget; 

        var selectedCompanyData = generateCompanyData(element);

        if (selectedCompanyData) {
            selectCompanyEvent(selectedCompanyData);

            var url = $(element).data("url");
            setTimeout(function () {
                window.location.href = url;
            }, 500);
        }
    }

    $(document).on('click', '.ga4-company-redirect, .ga4-view-company, .ga4-img-responsive', handleCompanyClick);
})();
